export default {"src":"/_next/static/media/onboarding-success.ade375ed.svg","height":323,"width":724,"blurWidth":0,"blurHeight":0};